<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation && presentation.content">
            <textarea
                type="text"
                v-model="presentation.content.core_message"
                class="form-control"
                id="dm-manuscript-core-message"
                :maxlength="recommendedLength"
                rows="4"
                :placeholder="
                    translate(
                        'Briefly describe the central message of your manuscript',
                    )
                "
                @change="validateAndSave()"
            />
        </div>
    </SwLayout>
</template>

<script>
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    mixins: [validationMixin],

    data() {
        return {
            recommendedLength: 500, // characters
        };
    },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        isValid() {
            if (!this.presentation) return false;
            if (!this.presentation.content) return false;
            if (!this.presentation.content.core_message) return false;
            return this.presentation.content.core_message.trim().length >= 1;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["savePresentation"]),

        validateAndSave() {
            this.validate();

            if (this.isValid) this.savePresentation();
        },
    },
};
</script>
